export default "<img style=\"width: 100%;\" [src]=\"img\" alt=\"\">";